import { focusRingStyle } from "./styles.mjs";
import { Text, TextStylesProvider } from "./Text.mjs";
import { ThemeOverride, useTheme } from "./ThemeProvider.mjs";
import { Flex } from "./Flex.mjs";
import { Icon } from "./Icon.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { match } from "@repo/utils/utils";
import { Button as Button$1 } from "react-aria-components";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/Button.tsx
const Button = ({ children, style: style$1, size = "md", variant = "primary", icon, iconColor, color, internal_slot, onPress, isDisabled, "aria-label": ariaLabel, className: classNameProp, flex, basis, grow, shrink, alignSelf }) => {
	const theme = useTheme();
	const borderRadius = theme.borderRadiuses.md;
	const getVariantStyles = () => {
		if (variant === "primary") return {
			background: theme.colors.accent9,
			border: `1px solid ${theme.colors.accentA7}`,
			...isDisabled ? {} : {
				"&:hover": {
					background: theme.colors.accent10,
					borderColor: theme.colors.accentA8
				},
				"&[data-pressed]": { background: theme.colors.accent11 }
			}
		};
		if (variant === "outline") return {
			borderStyle: "solid",
			borderWidth: theme.borderWidths.md,
			borderColor: theme.colors.sand6,
			...isDisabled ? {} : {
				"&:hover": {
					background: theme.colors.sand3,
					borderColor: theme.colors.sand7
				},
				"&[data-pressed]": {
					background: theme.colors.sand5,
					borderColor: theme.colors.sandA8
				}
			}
		};
		if (variant === "ghost") return {
			background: "transparent",
			border: "none",
			...isDisabled ? {} : {
				"&:hover": { background: theme.colors.sandA2 },
				"&[data-pressed]": { background: theme.colors.sandA4 }
			}
		};
		return {
			position: "relative",
			background: "transparent",
			border: "none",
			"&::after": {
				content: "\"\"",
				position: "absolute",
				inset: "-4px"
			},
			...isDisabled ? {} : { "&:hover": { color: theme.colors.sand12 } }
		};
	};
	const flexStyles = {
		flex: flex === true ? 1 : flex,
		flexBasis: basis,
		flexGrow: grow === true ? 1 : grow,
		flexShrink: shrink === true ? 1 : shrink,
		alignSelf
	};
	return /* @__PURE__ */ jsx(Button$1, {
		slot: internal_slot,
		className: [useStyles(focusRingStyle({ theme }), {
			position: "relative",
			borderRadius,
			padding: 0,
			overflow: "hidden",
			cursor: isDisabled ? "not-allowed" : void 0,
			opacity: isDisabled ? .5 : 1,
			...getVariantStyles(),
			...flexStyles,
			...style$1
		}), classNameProp].filter(Boolean).join(" "),
		onPress,
		isDisabled,
		"aria-label": ariaLabel,
		children: /* @__PURE__ */ jsx(ThemeOverride, {
			mode: variant === "primary" ? "dark" : theme.name,
			children: /* @__PURE__ */ jsxs(Flex, {
				align: "center",
				justify: "center",
				padding: match(size, {
					xxs: "xxs",
					xs: "xs",
					sm: "xs",
					md: "sm"
				}),
				gap: match(size, {
					xxs: "xxs",
					xs: "xs",
					sm: "xs",
					md: "sm"
				}),
				style: { borderRadius },
				children: [icon && /* @__PURE__ */ jsx(Icon, {
					name: icon,
					size,
					color: iconColor || color
				}), /* @__PURE__ */ jsx(TextStylesProvider, {
					weight: "medium",
					capsize: true,
					size,
					color,
					children: typeof children === "string" || typeof children === "number" || React.Children.toArray(children).every((child) => typeof child === "string" || typeof child === "number") ? /* @__PURE__ */ jsx(Text, { children }) : children
				})]
			})
		})
	});
};

//#endregion
export { Button };